import { TAB_STATES } from '../constants';
export const isTrashTab = tab => tab === TAB_STATES.TRASH;
export const isUnreadTab = tab => tab === TAB_STATES.UNREAD;
export const isAllTab = tab => tab === TAB_STATES.ALL;